import { useLocationMonitoringSchedule } from '@hakimo-ui/hakimo/data-access';
import {
  isDisarmWindowRelevant,
  MonitoringDisarmInfo,
} from '@hakimo-ui/hakimo/feature-shared';
import { Location, SiteDisarmWindow } from '@hakimo-ui/hakimo/types';
import { useCanUpdateLocation } from '@hakimo-ui/hakimo/util';
import { Alert, Button, HakimoSpinner } from '@hakimo-ui/shared/ui-base';
import { useEffect, useState } from 'react';
import UpdateMonitoringDisarmModal from './UpdateMonitoringDisarmModal';

interface Props {
  location: Location;
}

export function MonitoringDisarm(props: Props) {
  const { location } = props;
  const canUpdateLocation = useCanUpdateLocation();

  const [siteDisarmWindow, setSiteDisarmWindow] = useState<SiteDisarmWindow>();
  const [showUpdateDisarmModal, setShowUpdateDisarmModal] = useState(false);

  const { isLoading, isError, error, data } = useLocationMonitoringSchedule(
    location.id
  );

  useEffect(() => {
    if (data) {
      setSiteDisarmWindow(data.motionDisarmWindow ?? undefined);
    }
  }, [data]);

  const onUpdateDisarmStatus = () => setShowUpdateDisarmModal(true);
  const onCloseModal = () => setShowUpdateDisarmModal(false);
  const isRelevantWindow = isDisarmWindowRelevant(
    siteDisarmWindow?.endTimestamp
  );

  return (
    <div className="flex items-center gap-4">
      {isLoading && (
        <div className="flex h-24 items-center justify-center">
          <HakimoSpinner />
        </div>
      )}
      {isError && <Alert type="error">{error.message}</Alert>}
      <MonitoringDisarmInfo disarmWindow={siteDisarmWindow} />
      {canUpdateLocation && (
        <Button
          variant={isRelevantWindow ? 'outline' : 'error'}
          onClick={onUpdateDisarmStatus}
        >
          {isRelevantWindow ? 'Update Disarm Status' : 'Disarm Monitoring'}
        </Button>
      )}
      {showUpdateDisarmModal && location.tenant_id && (
        <UpdateMonitoringDisarmModal
          onClose={onCloseModal}
          siteDisarmWindow={siteDisarmWindow}
          isRelevantWindow={isRelevantWindow}
          locationId={String(location.id)}
          timezone={location.timezone || 'UTC'}
        />
      )}
    </div>
  );
}

export default MonitoringDisarm;
